module.exports = __webpack_public_path__ + "img/txt_info3.5836814a.png";